﻿﻿﻿<iframe id="analytics"
        style="height:90vh;display:block; width: -webkit-fill-available" 
        src="https://app.powerbi.com/reportEmbed?reportId=2a0ecaaa-f06c-4e84-b507-17a44a87b9e7&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546"
        frameborder="0"
        allowFullScreen="true"></iframe>